
import { Component, Vue, Watch } from 'vue-property-decorator';
import InfoTooltip from '@/app/components/common/InfoTooltip.vue';
import { AuthorityType } from 'ah-api-gateways';
import SideNavSettingsLink from './SideNavSettingsLink.vue';
import SideNavActivityLink from './SideNavActivityLink.vue';
import { useAuthStore } from '@/app/store/authModule';

@Component({
  components: {
    InfoTooltip,
    SideNavActivityLink,
    SideNavSettingsLink,
  },
})
export default class AdminResponsiveNav extends Vue {
  private settingsOpen: boolean = false;

  get authStore() {
    return useAuthStore();
  }

  get canViewQuotes() {
    return this.authStore.hasAuthorities(AuthorityType.VIEW_QUOTES);
  }

  @Watch('this.$route.fullPath', { immediate: true })
  onRouteChange() {
    this.settingsOpen = this.$route.fullPath.includes('/admin/settings');
  }

  toggleSettings() {
    this.settingsOpen = !this.settingsOpen;
  }
}
